import { APP_INITIALIZER, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { RouteService } from './services/route/route.service';

function initializeRoutes(routeService: RouteService, router: Router) {
  return () => {
    const routes = routeService.createRoutes();
    router.resetConfig(routes);
  };
}

@NgModule({
  imports: [
    RouterModule.forRoot([], {
      enableTracing: false,
      resolveNavigationPromiseOnError: false
    })
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeRoutes,
      deps: [RouteService, Router],
      multi: true
    }
  ]
})
export class AppRoutingModule {}
